/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Ref_N5Inputs */

const en_csv_to_json_ref_n5 = /** @type {(inputs: Csv_To_Json_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No type guessing at all, so this stays text rather than becoming 100000.`)
};

const ko_csv_to_json_ref_n5 = /** @type {(inputs: Csv_To_Json_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타입 추측을 전혀 하지 않으므로 100000이 되지 않고 텍스트로 남습니다.`)
};

const ja_csv_to_json_ref_n5 = /** @type {(inputs: Csv_To_Json_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`型推測を一切しないので、100000 にならずテキストとして残ります。`)
};

/**
* | output |
* | --- |
* | "No type guessing at all, so this stays text rather than becoming 100000." |
*
* @param {Csv_To_Json_Ref_N5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_ref_n5 = /** @type {((inputs?: Csv_To_Json_Ref_N5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Ref_N5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_ref_n5(inputs)
	if (locale === "ko") return ko_csv_to_json_ref_n5(inputs)
	return ja_csv_to_json_ref_n5(inputs)
});